import { AppDomainConfig } from "../../envConfig";
import app from "../app";

// demoapp organization is created automatically by the backend for review apps/local/dev/stag environments.
// not available on prod
// it is for testing purpose

const config: Partial<AppDomainConfig> = {
  ...app,
  domains: ["app"],
  id: "demoapp",
  name: "Demo App",
  slug: "demoapp",
};

export default config;
